<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:25:25
 * @LastEditors  : M.D.
 * @Description: 商品评价
 * @Remarks:
 -->
<template>
  <el-row :gutter="20">
    <el-col :span="20" :offset="2">
      <div class="pay-box">
        <p>微信扫一扫付款</p>
        <div class="pay-fee">应付金额¥{{ orderData.fee.toFixed(2) }}</div>
        <canvas class="pay-code" id="qrcode" ref="qrcode"></canvas>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api/ord-api'
import QRCode from 'qrcode'

export default {
  props: {},
  data () {
    return {
      orderData: { fee: 0 },
      interval: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.getPayQr()
  },
  mounted () {
  },
  activated () {

  },
  deactivated () {

  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  beforeDestory () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  watch: {},
  methods: {
    async getPayQr () {
      const res = await API.getPayQr({ orderNumber: this.$route.query.orderId })
      this.orderData = res.data.result
      this.qrcode()
    },
    qrcode (res) {
      var canvas = document.getElementById('qrcode')
      QRCode.toCanvas(canvas, this.orderData.qrCode, { width: 150 }, function (error) {
        if (error) console.error(error)
      })

      // let qrcode = new QRCode('qrcode', {
      //   width: 150, // 设置宽度，单位像素
      //   height: 150, // 设置高度，单位像素
      //   text: this.orderData.qrCode // 设置二维码内容或跳转地址
      // })
      // console.log(qrcode)
      this.checkIsPay()
      this.interval = setInterval(this.checkIsPay, 1000 * 3)
    },
    async checkIsPay () {
      const res = await API.checkIsPay({ state: this.orderData.state })
      console.log(JSON.stringify(res.data.statusCode))
      if (res.data.statusCode === '200') { // ：为200表示已支付，201继续轮询，301表示二维码失效
        clearInterval(this.interval)
        this.goPayResult(1)
      } else if (res.data.statusCode === '301') {
        this.$alert('二维码失效，请重新下单', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            setTimeout(() => {
              this.$router.go(-1)
            }, 300)
          }
        })
      }
    },
    goPayResult (state) {
      this.$router.push({ name: 'payResult', query: { payState: state } })
    }
  }
}
</script>

<style lang="stylus">
  .pay-box
    width 100%
    height 100%
    padding 50px
    text-align center
    background-color white
    margin-top 20px
    margin-bottom 60px

    .pay-fee
      color #FF9D55
      font-size 18px

    .pay-code
      margin-top 20px

      img
        display initial !important
</style>
